import styled from 'styled-components'

import colors from './colors'

const Label = styled.label`
  display: block;
  font-size: 1rem;
  font-weight: 500;
  margin: 1.5rem 0 .5rem;
`
const TextInput = styled.input`
  padding: .5rem;
  border-radius: 3px;
  width: 100%;
  font-size: ${p => p.large ? '1.6rem' : '1rem'};
  font-weight: 500;
  border: none;
  margin: 0;
  outline: none;
  cursor: pointer;
  background: ${colors.lightGray};
  opacity: .8;

  &:hover {
    opacity: .9;
  }
  &:focus {
    opacity: 1;
  }
`
const TextInputClickToEdit = styled(TextInput)`
  margin: 0 -.5rem 0;
  transition: all .2s ease;
  background: white;
  opacity: .9;

  &:hover {
    background: ${colors.lightGray};
  }
  &:focus {
    background: ${colors.lightGray};
    opacity: 1;
  }
`
const Select = styled.select`
  padding: 1rem;
  height: 2rem;
  font-size: 1rem;
  border: none;
  margin: 0 .5rem 0 0;
  background: ${colors.lightBlue};
  color: ${colors.blue};
  /* -webkit-appearance: none; */
`

export {
  Label,
  TextInput,
  TextInputClickToEdit,
  Select,
}



// WEBPACK FOOTER //
// ./src/styles/forms.js